<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">
      <div id="icon-info-box" class="white-box">
      	<div id="icon-info-box-close" @click="$emit('close');"><span class="material-icons">close</span></div>
      	<div id="icon-info-box-content">
      		<table class="parking" v-if="tagId == 51 || tagId == 252 || tagId == 253  || primaryPlaceTag == 51 || primaryPlaceTag == 252 || primaryPlaceTag == 253">
      			<tr>
      				<td><div class="icon-label icon-label-large"><strong>Signaturforklaring for parkeringspladser</strong></div></td>
      			</tr>
      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: rgb(230, 023, 122);">
      							<div class="marker-icon"><span class="marker-text">P</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">0-5 ledige pladser</td>
      			</tr>

      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: rgb(255,208,62);">
      							<div class="marker-icon"><span class="marker-text">P</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">6-20 ledige pladser</td>
      			</tr>

      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: rgb(000,145,73);">
      							<div class="marker-icon"><span class="marker-text">P</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">20+ ledige pladser</td>
      			</tr>

      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: rgb(000,150,206);">
      							<div class="marker-icon"><span class="marker-text">P</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">Ingen livedata</td>
      			</tr>

      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: rgb(177,171,165);">
      							<div class="marker-icon"><span class="marker-text">P</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">Uden for åbningstid</td>
      			</tr>

      			<tr>
      				<td>
      					<div class="grey_nocover info-icon">
                  <div class="info-icon-closed">
        						<div class="marker explain-div-marker">
        							<div class="parking-icon" style="background-color: rgb(000,150,206);">
        								<div class="marker-icon">
                          <span class="marker-text">P</span>
                          <div class="closed-line"></div>
                        </div>
        							</div>
        						</div>
        					</div>
                </div>
      				</td>
      				<td class="left-text">Rød streg over ikonet: Midlertidigt/permanent nedlagt</td>
      			</tr>

      			<tr>
      				<td>
      					<div class="blue_cover info-icon hat-icon">
      						<div class="marker explain-div-marker">
      							<div class="parking-icon" style="background-color: rgb(000,150,206);">
      								<div class="marker-icon"><span class="marker-text">P</span></div>
      							</div>
      						</div>
      						<div class="marker-hat marker-hat-explain rotate-left-90">
      							<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      								viewBox="0 0 404.258 404.258" style="fill:rgb(000,150,206);" xml:space="preserve">
      								<polygon points="138.331,0 114.331,18 252.427,202.129 114.331,386.258 138.331,404.258 289.927,202.129 "/>
      						  </svg>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">"Tag" på ikonet: Parkering i kælder eller p-hus</td>
      			</tr>

      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: rgb(000,150,206);">
      							<div class="marker-icon"><span class="marker-text">MC</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">Motorcykelparkering</td>
      			</tr>

      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: rgb(000,150,206);">
      							<div class="marker-icon"><span class="marker-text">PA</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">Patientafsætning</td>
      			</tr>

      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: rgb(000,150,206);">
      							<div class="marker-icon"><span class="marker-text">PB</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">Park + Bike</td>
      			</tr>
      		</table>
      		<table class="handicapParking" v-if="tagId == 56 || primaryPlaceTag == 56">
      			<tr>
      				<td><div class="icon-label icon-label-large"><strong>Signaturforklaring for handicapparkering</strong></div></td>
      			</tr>
      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: rgb(000,150,206);">
      							<div class="marker-icon"><span class="marker-text">HP</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">Kommunalt ejet handicapparkering</td>
      			<tr>
      				<td>
      					<div class="marker explain-div-marker">
      						<div class="parking-icon" style="background-color: #565656;">
      							<div class="marker-icon"><span class="marker-text">HP</span></div>
      						</div>
      					</div>
      				</td>
      				<td class="left-text">Privat ejet handicapparkering</td>
      			</tr>
      		</table>
      		<table class="roadWork" style="width: 100%;" v-if="tagId == 115  || primaryPlaceTag == 115">
      			<tbody>
      				<tr>
      					<td class="layer-icon"><img src="https://apps.odenserundt.dk/media/icons/vejarbejde.svg" style="height: 25px; width: 25px; display: inline-block;">
      					<img src="https://apps.odenserundt.dk/media/icons/trafikinfo.svg" style="height: 25px; width: 25px; display: inline-block;"></td>
      					<td class="description"><label for="road-info-checkbox">Vejarbejde og trafikinfo</label></td>
      				</tr>
      				<tr>
      					<td class="layer-icon"><img src="https://apps.odenserundt.dk/media/icons/roadsigns/e5.svg" style="height: 25px; width: 25px;"></td>
      					<td class="description"><label for="oneway-checkbox">Ensretning for bilister</label></td>
      				</tr>
      				<tr>
      					<td class="layer-icon"><img src="https://apps.odenserundt.dk/media/icons/roadsigns/l1.svg" style="height: 25px; width: 25px;"></td>
      					<td class="description"><label for="road-closed-checkbox">Vejlukning for bilister</label></td>
      				</tr>
      				<tr>
      					<td class="layer-icon"><img src="https://apps.odenserundt.dk/media/icons/roadsigns/vl1.svg" style="height: 25px; width: 25px;"></td>
      					<td class="description"><label for="no-entry-checkbox">Indkørselsforbud for bilister</label></td>
      				</tr>
      				<tr>
      					<td class="layer-icon"><img src="https://apps.odenserundt.dk/media/icons/roadsigns/vf1.svg" style="height: 25px; width: 25px;"></td>
      					<td class="description"><label for="turn-restriction-checkbox">Svingrestriktion for bilister</label></td>
      				</tr>
      			</tbody>
      		</table>
      	</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    tagId: {

    },
    primaryPlaceTag: {

    }
  },
}
</script>

<style lang="css" scoped>

/* Icon Info */
#icon-info-box {
	position: fixed;
	z-index: 980;
	-webkit-transition: top 0.5s, left 0.5s;
  transition: top 0.5s, left 0.5s;
  padding: 30px 10px 10px 10px;
}

#icon-info-box-content {
	overflow-y: auto;
	max-height: 400px;
	/*padding-left: 10px*/
}

#icon-info-box-close {
	position: absolute;
	z-index: 990;
	height: 30px;
	width: 30px;
	right: 5px;
	top: 5px;
  cursor: pointer;
}

/*Landscape - XS*/
@media screen and (max-width: 767px) and (orientation: landscape) {
	.directions-overlay-box, #icon-info-box {
		width: 100%;
		height: 100%;
	}
}
/*Landscape - SM*/
@media screen and (min-width: 768px) and (max-width: 991px) and (orientation: landscape) {
	.directions-overlay-box, #icon-info-box {
		width: 400px;
		height: 100%;
		left: 50%;
		margin-left: -200px;
	}
}
/*Landscape - MD*/
@media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
	.directions-overlay-box, #icon-info-box {
		left: 50%;
		top: 50%;
		width: 400px;
		height: auto;
		margin-left: -200px;
		transform: translateY(-50%);
		-ms-transform: translateY(-50%);
		-webkit-transform: translateY(-50%);
	}
}
/*Landscape - LG*/
@media screen and (min-width: 1200px) and (orientation: landscape) {
	.directions-overlay-box, #icon-info-box {
		left: 50%;
		top: 50%;
		width: 400px;
		height: auto;
		margin-left: -200px;
		transform: translateY(-50%);
		-ms-transform: translateY(-50%);
		-webkit-transform: translateY(-50%);
	}
}
/*Portrait - XS*/
@media screen and (max-width: 767px) and (orientation: portrait) {
	.directions-overlay-box, #icon-info-box {
		width: 90%;
		top: 50%;
		left: 5%;
		max-height: 500px;
		transform: translateY(-50%);
		-ms-transform: translateY(-50%);
		-webkit-transform: translateY(-50%);
		margin-top: 20px;
	}
}
/*Portrait - SM*/
@media screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
	.directions-overlay-box, #icon-info-box {
		width: 100%;
		top: 50%;
		max-height: 500px;
		transform: translateY(-50%);
		-ms-transform: translateY(-50%);
		-webkit-transform: translateY(-50%);
	}
}

.directions-overlay-box-close-btn {
	position: absolute;
  height: 30px;
  top: 1px;
  right: 1px;
}
.explain-div-marker {
	position: relative;
	display: inline-block;
}

.info-icon {
	position: relative;
}

.text-in-icons-table, .text-in-icons-table tbody {
	display: inline-block;
}

.text-in-icons-table td {
	text-align: left;
	padding-left: 10px;
}

.parking tr, .handicapParking tr {
	display: table;
}

.parking tr td, .handicapParking tr td {
	display: table-cell;
}

.explain-div-marker {
	height: 30px;
	width: 60px;
	margin: 5px 15px 5px 5px;
}

.marker-hat-explain {
	left: 5px;
	top: -17px;
}

.left-text {
  vertical-align: middle;
}
</style>
